var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-link is-light mx-1"},[_vm._v(_vm._s(_vm.roleTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }